import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthoritiesEnum, IntegrationTypeEnum } from "~/types/enums";
import { Badge, Card, Grid, Icon, InputToggle, Link, Picture, Text } from "~/components-shared";
import integrationsActionCreators from "~/store/integrations/actions";
import integrationSelectors from "~/store/integrations/selectors";
import salesforceLogo from "~/assets/i/apps/salesforce_logo.svg";
import useAbacExt from "~/hooks/abac";
import api from "~/lib/api";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const Actions = styled.div`
  position: relative;
  z-index: 2;
`;
const authorities = [AuthoritiesEnum.INTEGRATIONS_WRITE, AuthoritiesEnum.ONBOARDING_COMPANY_INTEGRATIONS_WRITE, AuthoritiesEnum.SIGN_UP_INTEGRATE];
const SalesforceIntegrationCard = _ref => {
  let {
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    userHasOneOf
  } = useAbacExt();
  const dispatch = useDispatch();
  const integration = useSelector(integrationSelectors.getIntegrationByType(IntegrationTypeEnum.SALESFORCE));
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = value => {
    if (value) {
      api.salesforceInstall().then(_ref2 => {
        let {
          path
        } = _ref2;
        const width = 1000;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        window.open(path, "Install Salesforce", `width=${width},height=${height},left=${left},top=${top}`);
      });
      setIsExpanded(true);
    } else if (integration?.id) {
      dispatch(integrationsActionCreators.deleteStarted(integration.id));
    }
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    onClick: userHasOneOf(authorities) && integration ? () => setIsExpanded(prev => !prev) : undefined,
    elemBefore: /*#__PURE__*/React.createElement(Picture, {
      src: salesforceLogo,
      width: "30px",
      height: "30px",
      border: "squared",
      color: "transparent",
      s: {
        mr: 2
      }
    }),
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      element: "h3",
      display: "inline-block"
    }, "Salesforce"), integration && userHasOneOf(authorities) && /*#__PURE__*/React.createElement(Icon, {
      scale: 4,
      src: "chevron",
      rotate: isExpanded ? 0 : 180,
      s: {
        ml: 1,
        mb: 1
      }
    }), !!integration && !integration?.settings?.authorized && /*#__PURE__*/React.createElement(Icon, {
      src: "warningOutline",
      color: "warning",
      s: {
        mt: -0.5,
        ml: 2
      }
    })),
    elemAfter: /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(InputToggle, {
      display: "inline-block",
      value: !!integration,
      onChange: (value, event) => {
        event.stopPropagation();
        handleToggle(value);
      },
      disabled: !userHasOneOf(authorities)
    })),
    collapsed: !integration || !isExpanded,
    s: {
      mb: 3
    }
  }, rest), integration?.settings?.authorized && integration?.settings?.packageInstalled && /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    display: "block"
  }, t("CompanyIntegrations.connectedTo"), " ", /*#__PURE__*/React.createElement(Link, {
    href: integration?.settings?.orgUrl,
    color: "primary",
    underline: true
  }, integration?.settings?.orgName), " ", t("CompanyIntegrations.organization")), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 5,
    template: "1fr 170px",
    fullWidth: true,
    s: {
      mt: 2
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4
  }, "Salesforce API access:")), /*#__PURE__*/React.createElement(Grid.Cell, {
    justify: "end"
  }, integration?.settings?.authorized ? /*#__PURE__*/React.createElement(Badge, {
    color: "successTransparent",
    s: {
      py: 1.5,
      px: 0
    },
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "tick",
    s: {
      mt: -1
    }
  }), /*#__PURE__*/React.createElement(Text, {
    s: {
      ml: 1
    }
  }, "Authorized")) : /*#__PURE__*/React.createElement(Badge, {
    color: "dangerTransparent",
    s: {
      py: 1.5,
      px: 0
    },
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "warningOutline",
    s: {
      mt: -1
    }
  }), /*#__PURE__*/React.createElement(Text, {
    s: {
      ml: 1
    }
  }, "Unauthorized")))));
};
export default SalesforceIntegrationCard;